import React from 'react';
// import './Component/Cards.css';
import CardItem from './Component/CardItem';
import './Workscard.css'


const Workscard = () => {
  return (
    <div className='cards'>
      
      <div className='cards__container'>
        <div className='cards__wrapperr'>
        
          <ul className='cards__items'>
           <CardItem 
           src='images/Wachacardimg.jpg'
           text='Wacha TV app user experience development'
           label='UX Design'
           path='/WachaTv'
           /> 
           <CardItem
           src='images/pup.png'
           text='Pup mobile user experience design'
           label='UI,UX Design'
           path='/Pup'
         />

         <CardItem 
         src='images/Stalert.png'
         text='Stalert: UI/UX design project'
         label='UI,UX Design'
         path='/Stalert'
         />
         
         
          </ul>

          <ul className='cards__items'>
          <CardItem id='testpad'
          src='images/Acebank1.png'
          text='AceBank App Design'
          label='UX Design'
          path='/Acebank' 
        />

        <CardItem 
            src='images/Roava.png'
            text='Roava crossborder banking'
            label='UX Design'
            path='/Roava'
          />
          
          
        {/*  <CardItem
            src='images/BOE.jpg'
            text='Brand Experience Optimizer©'
            label='B.O.E'
            path='/products'
        /> */}  
        </ul>

          
          
          <ul className='cards__items'>
          <CardItem id='testpad'
          src='images/suitcomng.png'
          text='Suits.com.ng user experience design'
          label='UI/UX Design'
          path='/Suitscomng'
          />

          {/*
          <CardItem id='testpad'
          src='images/roadbuddies.jpg'
          text='Roadbuddies mobile signin page '
          label='UI/UX Design'
          path='/Roadbuddies'
      /> */}
         
      <CardItem 
        src='images/Androidscreenshoot.png'
        text='Homelove Interior: UI/UX design project'
        label='UI/UX Design'
        path='/Homelove'
        />
         
        </ul>

        


       
       
      
        <ul className='cards__items'>
        
        
          
        </ul>
        
        </div>
     
      </div>
    </div>
  );
}

export default Workscard